document.addEventListener("DOMContentLoaded", function () {
    console.log('Testimonials script loaded');
    const slider = document.getElementById("testimonialsSlider");
    if (!slider) return;

    const prevButton = document.querySelector(".prev-button");
    const nextButton = document.querySelector(".next-button");
    const testimonialsSection = document.querySelector(".testimonials-section");
    const cards = slider.querySelectorAll(".testimonial-card");

    // Максимальное число карточек на экране
    const MAX_VISIBLE = 3;

    let currentIndex = 0;
    let cardWidth, gap, visibleCards, maxIndex;
    
    // Debug mode - set to false in production
    const DEBUG_MODE = true;
    function debugLog(message, data) {
        if (DEBUG_MODE) {
            console.log(message, data);
        }
    }

    // Detect iOS - improved detection
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
                  /iPad|iPhone|iPod/.test(navigator.platform);

    // If iOS, add class and use native scroll
    /*
    if (isIOS && testimonialsSection) {
        testimonialsSection.classList.add('ios-native-scroll');
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        debugLog('iOS detected, using native scroll');
        return;
    }
     */

    // Initialize slider dimensions
    function initSliderDimensions() {
        // Actual card width
        cardWidth = cards[0].getBoundingClientRect().width;

        // Detect gap (fallback to 24px)
        const style = window.getComputedStyle(slider);
        gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 24;

        const sliderWidth = slider.getBoundingClientRect().width;
        const totalCardWidth = cardWidth + gap;

        // Calculate how many cards fit, but no more than MAX_VISIBLE
        visibleCards = Math.min(
            Math.floor((sliderWidth + gap) / totalCardWidth),
            cards.length,
            MAX_VISIBLE
        );

        // Compute max index
        maxIndex = Math.max(0, cards.length - visibleCards);

        // Clamp currentIndex
        if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
        }

        // Always update position & buttons (no animation)
        updateSliderPosition(false);

        debugLog('Slider Debug:', {
            cardWidth,
            gap,
            sliderWidth,
            visibleCards,
            maxIndex,
            totalCards: cards.length
        });
    }

    // Update slider position
    function updateSliderPosition(animate = true) {
        if (!animate) {
            slider.style.transition = "none";
        }
        const shift = -(currentIndex * (cardWidth + gap));
        slider.style.transform = `translateX(${shift}px)`;
        if (!animate) {
            // Force reflow then restore transition
            void slider.offsetHeight;
            slider.style.transition = "transform 0.3s ease-in-out";
        }
        updateButtonsState();
    }

    // Update buttons state
    function updateButtonsState() {
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= maxIndex;
        debugLog('Button State:', {
            currentIndex,
            maxIndex,
            nextDisabled: nextButton.disabled,
            prevDisabled: prevButton.disabled
        });
    }

    // Navigation buttons
    prevButton.addEventListener("click", () => {
        if (currentIndex > 0) {
            currentIndex--;
            updateSliderPosition();
        }
    });
    nextButton.addEventListener("click", () => {
        if (currentIndex < maxIndex) {
            currentIndex++;
            updateSliderPosition();
        }
    });

    // Keyboard navigation
    document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft" && !prevButton.disabled) {
            prevButton.click();
        } else if (e.key === "ArrowRight" && !nextButton.disabled) {
            nextButton.click();
        }
    });

    // Touch handling
    let touchStartX = 0, touchEndX = 0, isSwiping = false;
    slider.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
        isSwiping = true;
        slider.style.transition = "none";
    });
    slider.addEventListener("touchmove", (e) => {
        if (!isSwiping) return;
        const currentX = e.touches[0].clientX;
        const diff = touchStartX - currentX;
        const moveX = -(currentIndex * (cardWidth + gap) + diff);
        const maxMoveX = -(maxIndex * (cardWidth + gap));
        if (moveX > 50 || moveX < maxMoveX - 50) return;
        slider.style.transform = `translateX(${moveX}px)`;
    });
    slider.addEventListener("touchend", (e) => {
        if (!isSwiping) return;
        isSwiping = false;
        touchEndX = e.changedTouches[0].clientX;
        slider.style.transition = "transform 0.3s ease-in-out";
        const diff = touchStartX - touchEndX;
        const threshold = cardWidth / 3;
        if (Math.abs(diff) > threshold) {
            if (diff > 0 && currentIndex < maxIndex) {
                currentIndex++;
            } else if (diff < 0 && currentIndex > 0) {
                currentIndex--;
            }
        }
        updateSliderPosition();
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initSliderDimensions, 150);
    });

    // Initial setup
    initSliderDimensions();

    // Fallback recalculation after images load (for iOS Safari/layout)
    window.addEventListener("load", () => {
        setTimeout(() => {
            initSliderDimensions();
        }, 100);
    });
    setTimeout(() => {
        initSliderDimensions();
    }, 500);
});
